import React from 'react';
import Navbar from '../../components/Navbar';
import LabelEdit from '../../components/Label/LabelEdit';
import './LabelEditPage.css';

const LabelEditPage = () => {
  return (
    <div className="label-edit-page">
      <Navbar />
      <div className="label-edit-content">
        <h2>Edit Label</h2>
        <LabelEdit />
      </div>
    </div>
  );
};

export default LabelEditPage;
